import React, { useState, useEffect, useRef } from "react";
import Header from "./../Header";
import Sidebar from "./../Sidebar";
import CandidateTab from "./../CandidateTab";
import NotificationPanels from "./../NotificationPanels";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/candidate-national-id.css";
import "../../assets/css/form.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getNIDDetails,
  uploadFileViaMultipartNID,
  saveNIDDetails,
  removeUploadedFile,
  deleteSaveNIDDetails,
  getNIDDetailsWithOCR,
  getNidOCRFlag
} from "../../Actions/nidAction";
import NIDField from "./../NIDField";
import _ from "lodash";
import {
  validatePAN,
  validateAadhaar,
  validatePassport,
  validateAlphabetsAndSpace,
} from "../../Helper/common";
import Loader from "./../Common/loader";
import Footer from "./../Footer.js";
import { toast } from "react-toastify";
import StepCount from "./../Common/StepCount";
import ClientSideBar from "./../Partials/ClientSideBar";
import ClientHeader from "./../Partials/ClientHeader";
import NationalIDTab from "./NationalIDTab";
import SelfieComponent from "../../UI_Design/InstantNIDWithOCR/TakeSelfie/SelfieComponent";
import ProgressHeading from "../Common/ProgressHeading.jsx";
import IntantNIDContainer from "./IntantNIDContainer.jsx";

const NationalIDNew = () => {
  const navigate = useNavigate();
  //Handling Form Reference
  const form = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    aadhaarNumber: null,
    documentType: null,
  });

  const [nidDetails, setNIDDetails] = useState({});
  const [unsavedNIDDetails, setUnsavedNIDDetails] = useState({});
  const [deletedFileName, setDeletedFileName] = useState(null);
  const [addedFileName, setAddedFileName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [disabledOptionsArray, setDisabledOptionsArray] = useState([]);
  const [confirmedAadhaar, setConfirmedAadhaar] = useState("");
  const [confirmedAadhaarError, setConfirmedAadhaarError] = useState(false);
  const [showConfirmedAadhaar, setShowConfirmedAadhaar] = useState(false);
  const [role,setRole]=useState();
  const [showSelfieUpload, setShowSelfieUpload]=useState(false);
  const [isOCR,setIsOCR]=useState('');

  const storeData = useSelector((state) => state.nidDetails);
  const storeData2 = useSelector((state) => state.uploadFilesData);
  const storeData3 = useSelector((state) => state.saveNidDetailsData);
  const storeData4 = useSelector((state) => state.deletedFilesData);
  const storeDataUser = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const { nidDetailsData, loading: getNIDLoading } = storeData;
  const { nidUploadFilesData, loading: uploadFileLoading } = storeData2;
  const { saveNIDDetailsData, loading: saveNIDDetailsDataLoading } = storeData3;
  const { deleteUploadedFileData, loading: deleteUploadedFileDataLoading } =storeData4;
  const { userData } = storeDataUser;
  console.log(userData);
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      localStorage.removeItem('activeNIDTab');
      // localStorage.removeItem('NIDSaved');
    }
  }, []);

  useEffect(() => {
    if (typeof getNIDLoading !== "undefined" && getNIDLoading !== null) {
      if (getNIDLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [nidDetailsData]);

  useEffect(() => {
    if (
      typeof uploadFileLoading !== "undefined" &&
      uploadFileLoading !== null
    ) {
      if (uploadFileLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [nidUploadFilesData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof saveNIDDetailsDataLoading !== "undefined" &&
      saveNIDDetailsDataLoading !== null
    ) {
      if (saveNIDDetailsDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveNIDDetailsData, storeData3]);

  useEffect(() => {
    if (
      typeof deleteUploadedFileDataLoading !== "undefined" &&
      deleteUploadedFileDataLoading !== null
    ) {
      if (deleteUploadedFileDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        // setUnsavedNIDDetails(_.cloneDeep(nidDetails));
        // 
         if(userData.is_instant_verification_required == 1 && isOCR){
        // dispatch(getNIDDetailsWithOCR())
         }
         else{
          // dispatch(getNIDDetails());
         }
      }
    }
  }, [deleteUploadedFileData, storeData4]);

  let allTabs;

  useEffect(() => {
    if (
      typeof nidDetailsData.data !== "undefined" &&
      nidDetailsData.data !== null
    ) {
      if(nidDetailsData.is_selfie_enabled ==1){
        setShowSelfieUpload(true);
      }
      else{
        setShowSelfieUpload(false);
      }
      if (Object.keys(unsavedNIDDetails).length === 0) {
        setNIDDetails(nidDetailsData.data);
        createErrorData(nidDetailsData.data);
        createDisabledOptions(nidDetailsData.data);
        if(nidDetails?.fields)
        allTabs = Object.keys(nidDetails?.fields);
      } else {
        if (deletedFileName) {
          handleDeletedFile();
        }
        if (addedFileName) {
          handleAddedFile(nidDetailsData.data);
        }
      }
    }
  }, [nidDetailsData, storeData]);

  const handleAddedFile = (newData) => {
    const [fieldKey, fieldName, fieldIndex = null] = addedFileName.split("-");
    const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
    if (fieldIndex) {
      for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
        if (
          updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
          fieldIndex
        ) {
          const newVal = newData.fields[fieldKey][fieldName][i].value;
          updatedUnsavedData.fields[fieldKey][fieldName][i].value = newVal;
        }
      }
    } else {
      for (var i in updatedUnsavedData.fields[fieldKey]) {
        if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
          const newVal = newData.fields[fieldKey][i].value;
          updatedUnsavedData.fields[fieldKey][i].value = newVal;
        }
      }
    }
    setNIDDetails(updatedUnsavedData);
    setAddedFileName(null);
    createErrorData(updatedUnsavedData);
    createDisabledOptions(updatedUnsavedData);
  };

  const handleDeletedFile = () => {
    const [fieldKey, fieldName, fieldIndex = null] = deletedFileName.split("-");
    const updatedUnsavedData = _.cloneDeep(unsavedNIDDetails);
    if (fieldIndex) {
      for (var i in updatedUnsavedData.fields[fieldKey][fieldName]) {
        if (
          updatedUnsavedData.fields[fieldKey][fieldName][i].field_name ===
          fieldIndex
        ) {
          updatedUnsavedData.fields[fieldKey][fieldName][i].value = "";
        }
      }
    } else {
      for (var i in updatedUnsavedData.fields[fieldKey]) {
        if (updatedUnsavedData.fields[fieldKey][i].field_name === fieldName) {
          updatedUnsavedData.fields[fieldKey][i].value = "";
        }
      }
    }
    setNIDDetails(updatedUnsavedData);
    setDeletedFileName(null);
    createErrorData(updatedUnsavedData);
    createDisabledOptions(updatedUnsavedData);
  };
  useEffect(() => {
    if (
      typeof nidUploadFilesData !== "undefined" &&
      Object.keys(nidUploadFilesData).length > 0 &&
      Object.keys(nidDetails).length > 0
    ) {
      handlePreviewData(nidUploadFilesData);
    }
  }, [nidUploadFilesData, storeData2]);

  useEffect(() => {
    const hasReferenceNumber =
      saveNIDDetailsData && saveNIDDetailsData.data ? true : false;
    if (hasReferenceNumber) {
      const referenceNumber = saveNIDDetailsData.data.reference_number;
      const groupID = saveNIDDetailsData.data.group.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
      dispatch(deleteSaveNIDDetails());
    }
  }, [saveNIDDetailsData, storeData3]);

  useEffect(() => {
    const fetchData = async () => {
      // dispatch(getNIDDetails());
      setIsLoading(false);
      dispatch(getNidOCRFlag(callbackApi));


      // if(userData?.data?.is_instant_verification_required == 1 || userData?.is_instant_verification_required == 1){
      //   dispatch(getNIDDetailsWithOCR())
      //    }
      //    else{
      //     dispatch(getNIDDetails());
      //    }
      // localStorage.removeItem('activeNIDTab');
    };

    fetchData();
  }, []);

  const callbackApi = (data) => {
    if(data){
      console.log(data);
      if(userData?.data?.is_instant_verification_required == 1 && data.config || userData?.is_instant_verification_required == 1 && data.config){
        setIsOCR(true);     
        dispatch(getNIDDetailsWithOCR())
         }
         else{
          setIsOCR(false);     
          dispatch(getNIDDetails());
         }
    }
    setIsLoading(true);
  }

  const createDisabledOptions = (data) => {
    if (data?.fields?.NID_Default_Field) {
      let arr = [];
      for (let i = 0; i < data.fields.NID_Default_Field.length; i++) {
        arr.push(data.fields.NID_Default_Field[i][0].value);
      }
      setDisabledOptionsArray(arr);
    }
  };
  const handlePreviewData = (data) => {
    for (let i in data) {
      if (i.includes("NID_Default_Field")) {
        const [field, index, fieldName] = i.split("-");
        let updatedNIDDetails = _.cloneDeep(nidDetails);
        for (let j in updatedNIDDetails.fields[field][index]) {
          if (
            updatedNIDDetails.fields[field][index][j].field_name === fieldName
          ) {
            updatedNIDDetails.fields[field][index][j].value = data[i].preview;
            updatedNIDDetails.fields[field][index][j].id = data[i].docId;
            setErrorData((prevState) => ({
              ...prevState,
              [i]: false,
            }));
            setNIDDetails(updatedNIDDetails);
          }
        }
      } else {
        const [field, fieldName] = i.split("-");
        let updatedNIDDetails = _.cloneDeep(nidDetails);
        for (let j in updatedNIDDetails.fields[field]) {
          if (updatedNIDDetails.fields[field][j].field_name == fieldName) {
            updatedNIDDetails.fields[field][j].value = data[i].preview;
            updatedNIDDetails.fields[field][j].id = data[i].docId;
            setErrorData((prevState) => ({
              ...prevState,
              [i]: false,
            }));
            setNIDDetails(updatedNIDDetails);
          }
        }
      }
    }
  };
  const createErrorData = (data) => {
    const errorObj = {};
    for (var i in data.fields) {
      if (i === "NID_Default_Field") {
        for (var j in data.fields[i]) {
          for (var k in data.fields[i][j]) {
            if (data.fields[i][j][k].is_mandatory === 1) {
              errorObj[`${i}-${j}-${data.fields[i][j][k].field_name}`] = false;
            }
          }
        }
      } else {
        for (var j in data.fields[i]) {
          if (data.fields[i][j].is_mandatory === 1) {
            errorObj[`${i}-${data.fields[i][j].field_name}`] = false;
          }
        }
      }
    }
    setErrorData(errorObj);
  };

  const saveNidDetails = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let hasError = false;
    let errors = _.cloneDeep(errorData);
    for (let i in nidDetails.fields) {
      if (i === "NID_Default_Field") {
        for (let j in nidDetails.fields[i]) {
          for (let k in nidDetails.fields[i][j]) {
            if (
              nidDetails.fields[i][j][k].is_mandatory === 1 &&
              (nidDetails.fields[i][j][k].value === "" ||
                nidDetails.fields[i][j][k].value === null)
            ) {
              if (
                nidDetails.fields[i][j][k].field_name.includes("back") ||
                nidDetails.fields[i][j][k].field_name.includes("front")
              ) {
                let isRequired = true;
                const nidSelected = nidDetails.fields[i][j][0].value;
                const docSide = nidDetails.fields[i][j][k].field_name.includes(
                  "back"
                )
                  ? "back"
                  : "front";
                if (nidSelected == "PAN CARD" && docSide == "back") {
                  isRequired = false;
                }
                if (
                  nidSelected == "AADHAAR" &&
                  (docSide == "back" || docSide == "front")
                ) {
                  isRequired = false;
                }
                hasError = isRequired == true ? true : false;
                errors[`${i}-${j}-${nidDetails.fields[i][j][k].field_name}`] =
                  isRequired == true ? true : false;
              } else {
                hasError = true;
                errors[
                  `${i}-${j}-${nidDetails.fields[i][j][k].field_name}`
                ] = true;
              }
            }
          }
        }
      } else {
        for (let j in nidDetails.fields[i]) {
          const isMandatory = nidDetails.fields[i][j].is_mandatory;
          const fieldValue = nidDetails.fields[i][j].value;
          if (isMandatory == 1 && (fieldValue == "" || fieldValue == null)) {
            hasError = true;
            errors[`${i}-${nidDetails.fields[i][j].field_name}`] = true;
          }
        }
      }
    }
    for (var i in errors) {
      if (errors[i] == true) {
        hasError = true;
        break;
      }
    }
    if (showConfirmedAadhaar) {
      if (confirmedAadhaarError == true) {
        hasError = true;
      } else if (confirmedAadhaar == "") {
        hasError = true;
        setConfirmedAadhaarError(true);
      }
    }
    setErrorData(errors);
    if (hasError) {
      setIsLoading(false);
      window.scrollTo(0, 0);
      return;
    }
    sendNidDetails();
  };

  const sendNidDetails = async () => {
    let selectedDocs = [];
    let nid_selected = [];
    let ele_doc_name = [];
    let ele_doc_numb = [];
    let ele_check_id = [];

    for (let i in nidDetails.fields) {
      if (i == "NID_Default_Field") {
        for (let j in nidDetails.fields[i]) {
          for (let k in nidDetails.fields[i][j]) {
            if (nidDetails.fields[i][j][k].field_name == "nid_selected[]") {
              selectedDocs.push(nidDetails.fields[i][j][k].value);
            }
            if (nidDetails.fields[i][j][k].field_name == "ele_doc_name[]") {
              ele_doc_name.push(nidDetails.fields[i][j][k].value);
            }
            if (nidDetails.fields[i][j][k].field_name == "ele_doc_numb[]") {
              ele_doc_numb.push(nidDetails.fields[i][j][k].value);
            }
            if (nidDetails.fields[i][j][k].field_name == "ele_check_id[]") {
              ele_check_id.push(nidDetails.fields[i][j][k].value);
            }
          }
        }
      } else {
        for (let j in nidDetails.fields[i]) {
          if (nidDetails.fields[i][j].field_name == "nid_selected[]") {
            selectedDocs.push(nidDetails.fields[i][j].value);
          }
          if (nidDetails.fields[i][j].field_name == "ele_doc_name[]") {
            ele_doc_name.push(nidDetails.fields[i][j].value);
          }
          if (nidDetails.fields[i][j].field_name == "ele_doc_numb[]") {
            ele_doc_numb.push(nidDetails.fields[i][j].value);
          }
          if (nidDetails.fields[i][j].field_name == "ele_check_id[]") {
            ele_check_id.push(nidDetails.fields[i][j].value);
          }
        }
      }
    }

    for (let i in selectedDocs) {
      for (let j in nidDetails.Default_Nid_Dropdown) {
        if (selectedDocs[i] == nidDetails.Default_Nid_Dropdown[j]) {
          nid_selected.push(j);
        }
      }
    }

    await dispatch(
      saveNIDDetails(nid_selected, ele_doc_name, ele_doc_numb, ele_check_id)
    );
  };

  const handleError = (name, val, fieldKey, index, nidFieldIndex) => {
    const fieldArr =
      fieldKey === "NID_Default_Field"
        ? nidDetails.fields[fieldKey][nidFieldIndex]
        : nidDetails.fields[fieldKey];
    const errorKey =
      fieldKey === "NID_Default_Field"
        ? `${fieldKey}-${nidFieldIndex}-${name}`
        : `${fieldKey}-${name}`;
    let selectedDoc = null;
    for (var i in fieldArr) {
      if (fieldArr[i].field_name == "nid_selected[]") {
        selectedDoc = fieldArr[i].value;
        break;
      }
    }

    if (fieldKey === "NID_Default_Field") {
      if (name === "nid_selected[]") {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: val && val !== "" ? false : true,
        }));
      }
    } else {
      if (name === "nid_selected[]") {
        setErrorData((prevState) => ({
          ...prevState,
          [`${fieldKey}-${name}`]: val && val !== "" ? false : true,
        }));
      }
    }

    if (name.includes("name")) {
      setErrorData((prevState) => ({
        ...prevState,
        [errorKey]: !validateAlphabetsAndSpace(val),
      }));
    } else if (name.includes("numb")) {
      if (selectedDoc === "PAN CARD") {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: !validatePAN(val),
        }));
      }
      if (selectedDoc === "AADHAAR") {
        //for showing field to re-enter aadhaar
        if (fieldKey == "NID_Default_Field") {
          const hasError = !validateAadhaar(val);
          if (!hasError) {
            setShowConfirmedAadhaar(true);
            setConfirmedAadhaar("");
          } else {
            setShowConfirmedAadhaar(false);
            setConfirmedAadhaar("");
          }
        }
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: !validateAadhaar(val),
        }));
      }
      if (selectedDoc === "PASSPORT") {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: !validatePassport(val),
        }));
      }
      if (selectedDoc === "VOTER ID") {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: val !== "" ? false : true,
        }));
      }
      if (selectedDoc === "") {
        setErrorData((prevState) => ({
          ...prevState,
          [errorKey]: val !== "" ? false : true,
        }));
      }
    }
  };

  const handleInputChange = (name, val, fieldKey, index, nidFieldIndex) => {
    handleError(name, val, fieldKey, index, nidFieldIndex);
    if (fieldKey == "NID_Default_Field" && name === "nid_selected[]") {
      let arr = _.cloneDeep(disabledOptionsArray);
      arr[nidFieldIndex] = val;
      setDisabledOptionsArray(arr);
      const currentVal =
        nidDetails.fields["NID_Default_Field"][nidFieldIndex][index].value;
      if ((currentVal !== "" || currentVal != null) && val !== currentVal) {
        removeAllDetails(val, index, nidFieldIndex);
        return;
      }
    }

    if (fieldKey !== "NID_Default_Field") {
      setNIDDetails((prevState) => ({
        ...prevState,
        fields: {
          ...prevState.fields,
          [fieldKey]: {
            ...prevState.fields[fieldKey],
            [index]: {
              ...prevState.fields[fieldKey][index],
              value: val,
            },
          },
        },
      }));
    } else {
      let updatedNidDetails = _.cloneDeep(nidDetails);
      updatedNidDetails.fields[fieldKey][nidFieldIndex][index].value = val;
      setNIDDetails(updatedNidDetails);
    }
  };

  const removeAllDetails = (val, index, nidFieldIndex) => {
    const nidDetailsClone = _.cloneDeep(nidDetails);
    for (var i in nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex]) {
      const fieldName =
        nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i]
          .field_name;
      if (fieldName !== "ele_check_id[]") {
        if (fieldName === "nid_selected[]") {
          nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
            val;
        } else {
          nidDetailsClone.fields["NID_Default_Field"][nidFieldIndex][i].value =
            "";
        }
      }
    }
    setNIDDetails(nidDetailsClone);
  };
  const uploadFile = async (
    docCheckID,
    docSubCheckID,
    docSide,
    fieldKey,
    checkIDData,
    selectedFile,
    fieldName,
    fieldNIDIndex,
    errorField
  ) => {
    if (docSubCheckID) {
      setAddedFileName(errorField);
      setUnsavedNIDDetails(_.cloneDeep(nidDetails));
      setIsLoading(true);
      await dispatch(
        uploadFileViaMultipartNID(
          docCheckID,
          docSubCheckID,
          docSide,
          fieldKey,
          checkIDData,
          selectedFile,
          fieldName,
          fieldNIDIndex
        )
      );
      // await dispatch(getNIDDetails());
      if(userData.is_instant_verification_required == 1 && isOCR){
       await  dispatch(getNIDDetailsWithOCR())
         }
         else{
         await dispatch(getNIDDetails());
         }
    } else {
      setAddedFileName(null);
      const msg = "Please select the document type first.";
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleFileDelete = async (recordArr, errorField) => {
    setIsLoading(true);
    setDeletedFileName(errorField);
    await dispatch(removeUploadedFile("nid_file", recordArr));
    // await dispatch(getNIDDetails());
    if(userData.is_instant_verification_required == 1 && isOCR){
     await dispatch(getNIDDetailsWithOCR())
       }
       else{
        await dispatch(getNIDDetails());
       }
  };

  const handleReEnter = (val) => {
    setConfirmedAadhaar(val);
    const nidFields = nidDetails.fields["NID_Default_Field"];
    let aadhaarNumber = null;
    for (var i in nidFields) {
      for (var j in nidFields[i]) {
        if (
          nidFields[i][j].field_name === "ele_doc_numb[]" &&
          nidFields[i][0].value === "AADHAAR"
        ) {
          aadhaarNumber = nidFields[i][j].value;
        }
      }
    }
    if (aadhaarNumber) {
      if (val == aadhaarNumber) {
        setConfirmedAadhaarError(false);
      } else {
        setConfirmedAadhaarError(true);
      }
    }
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {isLoading && <Loader />}
        {Object.keys(nidDetails).length > 0 &&  (
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto w-100-mbl bg-gray-mbl">
                <ProgressHeading/>
                <CandidateTab activeTab={"National Identity Check"} />
              </div>
              <div className="col bg-gray-mbl">
                {/*Form*/}
        {showSelfieUpload && isOCR && <SelfieComponent setShowSelfieUpload={setShowSelfieUpload}/>}
                {!showSelfieUpload && <div ref={form} className="p-3 form2 form-section">
                  <StepCount activeTab={"National Identity Check"} />
                  <h2 className="fnt-smi-bld">National ID</h2>
                  {/* <h6 style={{ color: "grey" }}>Adhaar Card, Voter ID</h6> */}
                  <hr />
                  {isOCR
                    ? <IntantNIDContainer
                      nidDetails={nidDetails}
                    />
                    : <NationalIDTab
                      tabs={nidDetails.fields}
                      nidDetailsNew={nidDetails}
                      defaultFieldName={allTabs?.length > 0 ? allTabs[0] : ''}
                      // defaultFieldData={}
                      errorData={errorData}
                      handleInputChange={handleInputChange}
                      uploadFile={uploadFile}
                      disabledOptionsArray={disabledOptionsArray}
                      handleFileDelete={handleFileDelete}
                      showConfirmedAadhaar={showConfirmedAadhaar}
                      confirmedAadhaar={confirmedAadhaar}
                      confirmedAadhaarError={confirmedAadhaarError}
                      handleReEnter={handleReEnter}
                      isOCRFlag={isOCR}
                    />
                  }

                  {/* {Object.keys(nidDetails.fields).map((field) => {
                    const nidFieldData = nidDetails.fields[field];
                    return (
                      <>
                        {field == "NID_Default_Field" &&
                          nidFieldData.map((nidField, key) => {
                            return (
                              <NIDField
                                field={nidField}
                                nidOptions={nidDetails.NID_Dropdown}
                                fieldKey={field}
                                errorData={errorData}
                                handleInputChange={handleInputChange}
                                nidFieldIndex={key}
                                uploadFile={uploadFile}
                                disabledOptionsArray={disabledOptionsArray}
                                handleFileDelete={handleFileDelete}
                                showConfirmedAadhaar={showConfirmedAadhaar}
                                confirmedAadhaar={confirmedAadhaar}
                                confirmedAadhaarError={confirmedAadhaarError}
                                handleReEnter={handleReEnter}
                              />
                            );
                          })}
                        {field != "NID_Default_Field" && (
                          <NIDField
                            field={nidFieldData}
                            nidOptions={nidDetails.Default_Nid_Dropdown}
                            fieldKey={field}
                            errorData={errorData}
                            handleInputChange={handleInputChange}
                            uploadFile={uploadFile}
                            handleFileDelete={handleFileDelete}
                          />
                        )}

                        <hr />
                      </>
                    );
                  })}

                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => saveNidDetails(e)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  {nidDetails.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          Submit for Preview
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )} */}
                </div>}
                <Footer />
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default NationalIDNew;
